import IntroductionDialog from 'components/StudentViewSubmission/IntroductionDialog';
import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/StudentViewSubmission/desktop';
import Mobile from 'pages/StudentViewSubmission/mobile';
import { PageContext } from 'pages/StudentViewSubmission/PageProvider';
import Tablet from 'pages/StudentViewSubmission/tablet';
import { useContext } from 'react';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { studentSubmissions } = useApp();
    const { device } = useViewport();

    const contextProps = useContext(PageContext);

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...contextProps} />,
            tablet: <Tablet {...contextProps} />,
            desktop: <Desktop {...contextProps} />,
        }[device];
    };

    if (!studentSubmissions) return <Loading />;

    return (
        <>
            {renderResponsiveLayout(device)}
            <IntroductionDialog
                open={contextProps.introductionDialog.open}
                onClose={() => contextProps.setIntroductionDialog({ open: false })}
            />
        </>
    );
};

export default PageLayout;
